import Tools from '@/components/tools/Tools.js'
import { toast, loading } from '@/shared/utils/UIHelper'
import { JWTService } from '@/shared/services/jwt'
import ActionsForm from '@/shared/mixins/actionsForm'

import {en, es, ptBR} from 'vuejs-datepicker/dist/locale'
import Datepicker from 'vuejs-datepicker'

import RegulationMixin from '@/store/module/regulation/mixin'
import RegulationAutoRepository from '@/shared/http/repositories/regulation/auto/regulationauto'
import RegulationAutoAnalyzeRepository from '@/shared/http/repositories/regulation/auto/regulationautoanalyze'
import RegulationAutoSchedulingRepository from '@/shared/http/repositories/regulation/auto/regulationautoscheduling'

import SinisterHeader from '@/components/regulation/auto/sinisterheader/sinisterheader.vue'
import SinisterAnalyzeForms from './sinisteranalyze-form'
import SinisterAnalyzeModel from './sinisteranalyze-model'

export default {
  name: 'SinisterAnalyze',
  props: [ 'clear' ],
  mixins: [
    ActionsForm,
    RegulationMixin
  ],
  data () {
    return {
      form: SinisterAnalyzeForms,
      data: SinisterAnalyzeModel,
      objRegulationAuto: null,
      tabIndex: 0,
      objList: [],
      isShowModalReturnRegulation: false,
      en: en,
      es: es,
      ptBR: ptBR,
      disableActionDateAnalyze: false
    }
  },
  components: {
    Datepicker,
    SinisterHeader
  },
  computed: {
    FieldSizeTip: function () {
      return this.$lang.Common.Tips.MaximumSize.replace('@SIZE@', this.form.emailAdm.maxlength)
    }
  },
  mounted () {
    this.onLoad()
  },
  watch: {
    // TODO RETIRAR APÓS REFACTOR
    clear: function () {
      this.onClear()
    }
  },
  methods: {
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
    },
    onLoad () {
      this.onClear()
      this.form.actionDate.value = this.moment().format('YYYY-MM-DD hh:mm:ss')

      var self = this
      if (this.hasRegulation) {
        RegulationAutoAnalyzeRepository.GetByRegulationAutoID(this.regulation.id)
          .then((response) => {
            var result = response.data.data
            if (result) {
              Tools.SetValueInForm(self.form, self.data, result)

              this.form.typeConclusionID.value = result.typeConclusionID
              this.form.lossTypeID.value = result.lossTypeID
              if (result.actionDate) {
                this.form.actionDate.value = result.actionDate
                this.disableActionDateAnalyze = true
              } else {
                this.disableActionDateAnalyze = false
              }

              this.data.urlBudgetSystem = result.urlBudgetSystem

              setTimeout(function (e) {
                self.form.hasNonconformityBudget.value = result.hasNonconformityBudget
              }, 400)

              setTimeout(function (e) {
                self.form.nonconformityBudgetReason.value = result.nonconformityBudgetReason
              }, 600)

              this.form.rescheduleInspection.value = result.rescheduleInspection
              this.form.emailAdm.value = result.emailAdm
            }
          })
          .catch((err) => {
            self.onException(err)
          })

        RegulationAutoSchedulingRepository.GetLastByRegulationAuto(this.regulation.id)
          .then((response) => {
            var result = response.data.data
            if (result) {
              this.form.instructions.value = result.instructions
              this.form.observations.value = result.observations
            }
          })
          .catch((err) => {
            self.onException(err)
          })
      }
    },
    onSave () {
      var self = this
      if (!this.data.id) {
        this.data.id = '00000000-0000-0000-0000-000000000000'
      }
      if (!this.form.id.value) {
        this.form.id.value = '00000000-0000-0000-0000-000000000000'
      }
      this.form.regulationAutoID.value = this.regulation.id
      if (Tools.ValidateForms(this.form, this.data, self)) {
        // Set default data
        this.data.dateUpdate = this.moment().format('YYYY-MM-DD hh:mm:ss')
        this.data.accountIDUpdate = JWTService.GetTokenPayload().AccountID
        if (this.data.hasOwnProperty('companyID')) {
          this.data.companyID = JWTService.GetTokenPayload().companyID
        }

        if (this.data) {
          if (this.data.id !== null && this.data.id !== '00000000-0000-0000-0000-000000000000') {
            this.onUpdate()
          } else {
            this.data.id = '00000000-0000-0000-0000-000000000000'
            this.data.status = 1
            this.onCreate()
          }
        } else {
          toast.error(this.$lang.Common.NoRecordInformed)
        }

        if (this.form.hasNonconformityBudget.value && this.form.hasNonconformityBudget.value === true) {
          this.isShowModalReturnRegulation = true
        } else {
          this.updateRegulationStageToDigitation()
        }
      }
    },
    onCreate () {
      loading.push()
      this.data.regulationAutoID = this.regulation.id
      if (Tools.ValidateForms(this.form, this.data, self)) {
        RegulationAutoAnalyzeRepository.Create(this.data)
          .then((response) => {
            var result = this.onResultObj(response)
            if (result !== null) {
              this.data.regulationAutoID = result.regulationAutoID
              this.onLoad()
            }
            this.onResult(response, true, true)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onUpdate () {
      loading.push()
      this.data.regulationAutoID = this.regulation.id
      if (Tools.ValidateForms(this.form, this.data, self)) {
        RegulationAutoAnalyzeRepository.Update(this.data)
          .then((response) => {
            this.onResult(response, true, true)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onChangeIsSurveyProductive () {
    },
    setIsSurveyProductive () {
    },
    setHasNonconformityBudget () {
    },
    setNonconformityBudgetReason () {
    },
    confirmReturnRegulation () {
      if (this.form && this.form.regulationAutoID.value !== '00000000-0000-0000-0000-000000000000') {
        RegulationAutoRepository.ReturnRegulationToExpert(this.form.regulationAutoID.value)
          .then((response) => {
            if (response && response.code > 0) {
              toast.success('<strong>Processo devolvido para o Perito!</strong>')
            }
          })
          .catch((err) => {
            this.onException(err)
          })
      }
      this.isShowModalReturnRegulation = false
    },
    updateRegulationStageToDigitation () {
      if (this.form && this.form.regulationAutoID.value !== '00000000-0000-0000-0000-000000000000') {
        RegulationAutoRepository.ChangeStageRegulationToDigitation(this.form.regulationAutoID.value)
          .then((response) => {
            if (response && response.code === 0) {
              toast.success('<strong>Estágio do Processo foi alterado para Digitação!</strong>')
            }
          })
          .catch((err) => {
            this.onException(err)
          })
      }
      this.isShowModalReturnRegulation = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/regulation/auto/analyze/sinisteranalyze.js